import React from 'react';
import {
    BusEvent,
    ClearMapLayerEvent,
    MapAvailableEvent,
    MapUnavailableEvent,
    ShowMapLayerEvent,
} from 'app/common/eventbus/Events';
import AppContext from 'app/common/context/AppContext';

interface MapPendingEventsComponentState {
    pendingEvents: { [id: number]: Array<BusEvent> };
    mapAvailable: { [id: number]: boolean };
}

/**
 * This component works as a "watchdog" for map events (ShowMapLayerEvent\,ClearMapLayerEvent) where it stores the events if the map is not ready to process them.
 * And when the map becomes available, it triggers the events in the same order.
 *
 * This was required because, if the user shows the map and activates some layer and then hides the map the map will be un mounted.
 * So, the next time it shows the map, the layer components could become mounted before the map and so the events triggered by them will be lost (no map listening for them)
 *
 */
export class MapPendingEventsComponent extends React.PureComponent<{}, MapPendingEventsComponentState> {
    constructor(props) {
        super(props);
        this.state = {
            mapAvailable: {},
            pendingEvents: [],
        };
        this.initBus();
    }

    render() {
        return <></>;
    }

    initBus() {
        AppContext.eventBus.register(MapAvailableEvent.NAME, (event: MapAvailableEvent) => {
            this.setState(
                {
                    mapAvailable: { ...this.state.mapAvailable, [event.mapId]: true },
                },
                () => this.triggerPendingEvents(event.mapId),
            );
        });
        AppContext.eventBus.register(MapUnavailableEvent.NAME, (event: MapAvailableEvent) => {
            this.setState({
                mapAvailable: { ...this.state.mapAvailable, [event.mapId]: false },
            });
        });
        AppContext.eventBus.register(ShowMapLayerEvent.NAME, (event: ShowMapLayerEvent) => {
            if (!this.state.mapAvailable[event.mapId]) {
                this.setState(prevState => {
                    const existingEvents = prevState.pendingEvents[event.mapId] ?? [];
                    return {
                        pendingEvents: { ...prevState.pendingEvents, [event.mapId]: [...existingEvents, event] },
                    };
                });
            }
        });

        AppContext.eventBus.register(ClearMapLayerEvent.NAME, (event: ClearMapLayerEvent) => {
            if (!this.state.mapAvailable[event.mapId]) {
                this.setState(prevState => {
                    const existingEvents = prevState.pendingEvents[event.mapId] ?? [];
                    return {
                        pendingEvents: { ...prevState.pendingEvents, [event.mapId]: [...existingEvents, event] },
                    };
                });
            }
        });
    }

    triggerPendingEvents(mapId: number) {
        this.setState(prevState => {
            prevState.pendingEvents[mapId]?.forEach(event => {
                AppContext.eventBus.publish(event);
            });
            return {
                pendingEvents: [],
            };
        });
    }
}
